<template>
  <div v-if="form" class="o-form">
    <div class="row">
      <div v-if="!submitted" class="col-md-8 offset-md-1">
        <h2 v-if="$isNotNullOrUndefined(item.headline)">
          {{ item.headline }}
        </h2>
        <span
          v-if="$isNotNullOrUndefined(item.description)"
          class="mb-5 pb-5"
          v-html="item.description"
        />

        <form
          v-if="form.pages"
          :id="form.id"
          ref="form"
          @submit.prevent="submit"
        >
          <div v-for="(page, index) in form.pages" :key="index" class="-page" :class="{ 'd-none' : index != currentPage }">
            <template v-if="$isNotNullOrUndefined(page.fieldSets)">
              <base-fieldset v-for="fieldset in page.fieldSets" :key="fieldset.index" :fieldset="fieldset" :form="form" />
            </template>
          </div>
        </form>

        <div>
          <base-button
            v-if="showPrev"
            class="-secondary"
            @click.native="prevPage"
          >
            {{ prevLabel }}
          </base-button>
          <button-with-loader
            v-if="showSubmit"
            :loading="isLoading"
            :text="submitLabel"
            class="-primary"
            @click.native="submit"
          />
          <base-button
            v-if="showNext"
            class="-secondary"
            @click.native="nextPage"
          >
            {{ nextLabel }}
          </base-button>
        </div>
      </div>
      <div v-else class="col-md-8 offset-md-1">
        <strong>{{ thankYouMessage }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import baseFieldset from '@/components/molecules/BaseFieldset'
import BaseButton from '@/components/atoms/BaseButton.vue'
import ButtonWithLoader from '@/components/molecules/ButtonWithLoader.vue'

export default {
  name: 'Forms',
  components: {
    baseFieldset,
    BaseButton,
    ButtonWithLoader
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    forceValue: {
      type: Object,
      default: () => {}
    }
  },
  async fetch () {
    if (this.item?.formPicker) {
      let {data} = await this.$repositories.form.byId(this.item?.formPicker);

      // Set default value for the hidden field
      if(this.forceValue && this.forceValue.fieldName && this.forceValue.value) {
        
          this.setDefaultValue(this.forceValue.fieldName, this.forceValue.value);
        
      }

      this.form = data;
    }
  },
  data () {
    return {
      currentPage: 0,
      isLoading: false,
      visibleFields: [],
      submitted: false,
      form: null,
      thankYouMessage: this.$t('FormSubmitThankYou','Tak, formularen er nu indsendt')
    }
  },
  computed: {
    showNext () {
      return  this.currentPage < (this.form?.pages?.length - 1)
    },
    showPrev () {
      return  this.currentPage > 0
    },
    showSubmit () {
      return this.currentPage == (this.form?.pages?.length - 1)
    },
    submitLabel () {
      return this.$isNotNullOrUndefined(this.form?.submitLabel) ? this.form?.submitLabel : this.$t('submit', 'Indsend');
    },
    nextLabel () {
      return this.$isNotNullOrUndefined(this.form?.nextLabel) ? this.form?.nextLabel : this.$t('next', 'Næste');
    },
    prevLabel () {
      return this.$isNotNullOrUndefined(this.form?.prevLabel) ? this.form?.prevLabel : this.$t('prev', 'forrige');
    },
    pageId () {
      return this.$store.getters['content/content/getPageId']
    }
  },
  watch: {
    forceValue: {
      handler: function (val) {
        if(val.fieldName && val.value);
        this.setDefaultValue(val.fieldName, val.value);
      },
      immediate: false,
    },
  },
  methods: {
    nextPage () {
      this.currentPage = this.currentPage+1;
    },
    prevPage () {
      this.currentPage = this.currentPage-1;
    },
    setDefaultValue (fieldName, value) {
      if (fieldName && value) {
        this.form.pages.forEach(page => {
          page.fieldSets.forEach(fieldSet => {
            fieldSet.containers.forEach(container => {
              container.fields.forEach(field => {
                if (field.name === fieldName) {
                  field.defaultValue = value;
                }
              });
            });
          });
        });
      }
    },
    /*
    async submit () {
      let formId = this.item.formPicker
      let pageId = this.pageId
      let formData = new FormData(this.$refs['form']);

      Object.entries(this.$refs['form']).forEach(entry => {
        if (entry[1].type === 'checkbox' && entry[1].name.includes('dataConsent')) {
          formData.set(entry[1].name, (entry[1].checked ? 'true' : 'false') );
        }
      });

      this.$validator.validateAll().then(async result => {
        if (result) {
          this.isLoading = true
          try {
            let {data} = await this.$repositories.form.submit(
              formId,
              pageId,
              formData
            );
            this.onSubmitSuccess(data);
          } catch ( error ) {
            console.error( error );
          }
        }
      });
    },*/

    async submit () {
      let formId = this.item.formPicker;
      let pageId = this.pageId;
      let form = this.$refs['form'];
      let formData = {};

      // Loop through form elements and construct JSON payload
      [...form.elements].forEach(element => {
        if (element.name) {
          if (element.type === 'checkbox') {
            formData[element.name] = element.checked;
          } else if (element.type === 'radio') {
            if (element.checked) {
              formData[element.name] = element.value;
            }
          } else {
            formData[element.name] = element.value;
          }
        }
      });

      this.$validator.validateAll().then(async result => {
        if (result) {
          this.isLoading = true;
          try {
            let { data } = await this.$repositories.form.submit(
              formId,
              pageId,
              formData // Now sending JSON instead of FormData
            );
            this.onSubmitSuccess(data);
          } catch (error) {
            console.error(error);
          }
        }
      });
    },

    onSubmitSuccess (data) {
      if (data?.value && data?.value.length && data?.type === 'thank_you') {
        this.thankYouMessage = data?.value;
        this.isLoading = false
        this.submitted = true
      }
      else if (data?.value && data?.value.length && data?.type === 'redirect_url') {
        window.location.href = data?.value;
      }
      else {
        this.isLoading = false
        this.submitted = true
      }
    }
  },
  provide () {
    return {
      $validator: this.$validator,
    };
  }
}
</script>